module.exports = __webpack_public_path__ + "static/media/star.c6aa41f4.svg";